import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params) {
    return store.dispatch('checkResponseApi', await Api().get('goodsissues', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('goodsissue?gi_id=' + data.gi_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('goodsissue', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('goodsissue', data, options))
  },

  async done (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('goodsissue/done', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('goodsissue', { data: data }, options))
  },

  async getLatestCode (data) {
    let param = '?warehouse_id=' + data.warehouse_id +
								'&short_name=' + data.short_name
    return store.dispatch('checkResponseApi', await Api().get('goodsissue/latest_code' + param))
  },

}



// WEBPACK FOOTER //
// ./src/api/GoodsIssueService.js